import { motion } from 'framer-motion'

const reviews = [
  {
    icon: '/assets/images/Frame34.svg',
    alt: 'Tripadvisor',
    title: "Tripadvisor Traveler's Choice 2025",
    subtitle: '(5,281 reviews)',
  },
  {
    icon: '/assets/images/image144.svg',
    alt: 'Google',
    title: 'Rated Excellent/4.8 stars',
    subtitle: '(5,281 reviews)',
  },
  {
    icon: '/assets/images/image24.svg',
    alt: 'Trustpilot',
    title: 'Trustpilot',
    subtitle: '(5,281 reviews)',
  },
]

export default function Reviews() {
  return (
    <>
      {/* MOBILE */}
     <section className="relative z-10 bg-[#F7FAF8] px-[7px] pb-[14px] pt-[12px] md:hidden">
        <div
          className="
            grid min-h-[126px] w-full grid-cols-3 items-stretch
            overflow-hidden rounded-[18px]
            
          "
        >
          {/* Tripadvisor */}
          <div className="flex min-w-0 flex-col items-center justify-center px-2 py-3 text-center">
            <img
              src="/assets/images/mobile-trip-ad.png"
              alt="Tripadvisor"
              className="h-[34px] w-[34px] shrink-0 object-contain"
            />

            <div className="mt-2 min-w-0 font-host leading-[1.15]">
              <p className="text-[12px] font-medium text-[#171717]">Tripadvisor</p>
              <p className="mt-[2px] text-[11px] font-medium text-[#171717]">2025</p>
              <p className="mt-[5px] text-[10px] text-[#7D8799]">5,281 reviews</p>
            </div>
          </div>

          {/* Google */}
          <div className="flex min-w-0 flex-col items-center justify-center border-l border-[#E5E5E5] px-2 py-3 text-center">
            <img
              src="/assets/images/image144.svg"
              alt="Google"
              className="h-[25px] w-[45px] shrink-0 object-contain"
            />

            <div className="mt-2 min-w-0 font-host leading-[1.15]">
              <p className="text-[12px] font-medium text-[#44506A]">Rated Excellent</p>
              <p className="mt-[3px] text-[10px] text-[#7D8799]">4.8 ★</p>
              <p className="mt-[4px] text-[10px] text-[#7D8799]">5,281 reviews</p>
            </div>
          </div>

          {/* Trustpilot */}
          <div className="flex min-w-0 flex-col items-center justify-center border-l border-[#E5E5E5] px-2 py-3 text-center">
            <img
              src="/assets/images/image24.svg"
              alt="Trustpilot"
              className="h-[36px] w-[36px] shrink-0 object-contain"
            />

            <div className="mt-2 min-w-0 font-host leading-[1.15]">
              <p className="text-[12px] font-medium text-[#171717]">Trustpilot</p>
              <p className="mt-[5px] text-[10px] text-[#7D8799]">5,281 reviews</p>
            </div>
          </div>
        </div>
      </section>

      {/* DESKTOP - KEEP EXISTING DESIGN */}
      <section className="relative z-0 hidden w-full border-t border-gray-200 bg-white overflow-hidden md:block">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-50px' }}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.15,
              },
            },
          }}
          className="mx-auto flex w-full max-w-[min(100%,1400px)] flex-col items-center justify-around gap-6 px-6 py-8 sm:flex-row sm:gap-4 sm:px-8 lg:h-[108px] lg:py-0"
        >
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: {
                  opacity: 1,
                  y: 0,
                  transition: {
                    duration: 0.5,
                    ease: 'easeOut',
                  },
                },
              }}
              className="flex items-center gap-3"
            >
              <img
                src={review.icon}
                alt={review.alt}
                className="h-10 w-10 object-contain sm:h-11 sm:w-11"
              />

              <div>
                <p className="font-host text-sm font-medium text-gray-900 sm:text-base lg:text-lg">
                  {review.title}
                </p>
                <p className="font-host text-xs font-medium text-gray-900 sm:text-sm lg:text-base">
                  {review.subtitle}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>
    </>
  )
}
